import { LitElement, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { closeIcon } from "@/assets/icons";

@customElement("sb-modal")
export class SbModal extends LitElement {
  private _cachedChildren: Node[] = [];

  createRenderRoot() {
    return this; // Light DOM
  }

  connectedCallback(): void {
    super.connectedCallback();
    if (this._cachedChildren.length === 0) {
      this._cachedChildren = Array.from(this.childNodes);
      this._cachedChildren.forEach((node) => this.removeChild(node));
    }
  }

  @property({ type: Boolean }) isOpen = false;
  @property({ type: Boolean }) showClose = true;
  @property({ type: String }) layoutClass = "";

  // Close handler – stops propagation and dispatches non-bubbling event
  private _handleClose = (e?: Event) => {
    if (e) {
      e.stopPropagation(); // Prevent click from reaching parent modals
    }
    this.dispatchEvent(
      new CustomEvent("close", {
        bubbles: false, // Prevents event from bubbling to parent modals
        composed: true, // Allows crossing shadow DOM if needed
      }),
    );
  };

  // Click on the overlay backdrop – closes only if click is directly on overlay
  private _handleOutsideClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      this._handleClose(e);
    }
  };

  render() {
    if (!this.isOpen) return nothing;

    return html`
      <div class="sb-modal-overlay"></div>
      <div class="sb-modal-container" @click=${this._handleOutsideClick}>
        <div part="modal-content" class="sb-modal-layout">
          ${this.showClose
            ? html`
                <div class="sb-modal-close-container">
                  <rtg-button
                    variant="ghost"
                    size="icon-sm"
                    part="modal-close-button"
                    @click=${this._handleClose}
                  >
                    ${closeIcon()}
                  </rtg-button>
                </div>
              `
            : nothing}
          ${this._cachedChildren}
        </div>
      </div>
    `;
  }
}
